import { SortableContainer } from 'react-sortable-hoc';
import TableCells from './TableCells';

export default SortableContainer(TableCells);
